import { getSourceIdForUserIdentity } from 'owa-account-source-list';
import {
    accountSourceDataTypeChecker,
    getAccountBySourceId,
    updateAccount,
} from 'owa-account-source-list-store';
import { logUsage } from 'owa-analytics';

// Updates the account associated with the specified user identity
export function updateConnectedAccountState(userIdentity: string, accountState: number) {
    const sourceId = getSourceIdForUserIdentity(userIdentity);
    const sourceIdFound = !!sourceId;
    let accountFound = false;
    if (sourceId) {
        const account = getAccountBySourceId(sourceId);
        if (account && accountSourceDataTypeChecker.isM365ConnectedMailbox(account)) {
            accountFound = true;
            account.accountState = {
                connectedAccountState: accountState,
            };

            updateAccount(account);
        }
    }

    logUsage('updateConnectedAccountStateForAccountSourceList', {
        sourceIdFound: sourceIdFound,
        accountFound: accountFound,
    });
}
